<div class="file">
    <div class="file__image">
        <img [src]="uploadData.filePreview | safe:'url'" appImgFallback alt="roboze-photo" />
    </div>
    <div class="file__metadata">
        <div class="metadata">
            <div class="metadata__item">
                <div class="metadata__item--file-name">
                    {{uploadData.fileName}}
                </div>
            </div>
            <div class="metadata__item">
                <div class="metadata__item--name">
                    {{'device.details.model' | translate}}:
                </div>
                <div class="metadata__item--value">
                    Roboze {{uploadData.modelName}}
                </div>
            </div>
            <div class="metadata__item">
                <div class="metadata__item--name">
                    {{'device.files.printing-material' | translate}}:
                </div>
                <div class="metadata__item--value" *ngFor="let material of uploadData.materials; trackBy: trackByFn">
                     {{material.name}} <span class="quantity">({{material.used | number :'1.0-3'}}{{material.unit}})</span>
                    <span *ngIf="material !== uploadData.materials[uploadData.materials.length-1]" class="me-1">,</span>
                </div>
            </div>
        </div>
        <div class="button">
            <button nbButton [status]="'primary'" [size]="'small'" (click)="nextStep()" tabindex="-1">
                {{"common.next" | translate}}
            </button>
        </div>
    </div>
</div>